import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import CharacterModalPlayer from './CharacterModalPlayer'

const CharacterModeling = () => {
const [characterName, setCharacterName] = useState('001.jpg')

const openModal = (data) => {
    setCharacterName(data)
}

  return (
    <>
        <Card className='no-border rounded-0 character-modeling container text-center'>
            <Card className="no-border rounded-0">
                <Card.Body>
                    <Card.Title className='character-modeling-title'> キャラクターモデリング </Card.Title>
                    <Row>
                        <Col xs={{ span:12, offset:0 }}>
                            <Card.Text className='character-modeling-text text-left'>
                            VRゲームやARフィギュア、仮想世界のアバターなど、キャラクターのモデリングには、生命感あふれる有機的な造形力と、キャラクターに生命を吹き込む「魂」を持ったアーティストが必要です。モデリング、テクスチャリング、リギング、アニメーションなど、それぞれの専門家が連携して行うことで、モデルに生命を吹き込むことができるのです。

                            </Card.Text>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className='no-border rounded-0'>
                <Row>
                    <Col xs={{ span:2, offset:1 }} md={{ span:2, offset:3 }}>
                        <Card.Img className='character-thumbnail' src={"/assets/character/thumbnail/005.jpg"} alt="" onClick = {() => openModal('005.jpg')} />
                    </Col>
                    <Col xs={{ span:2, offset:5 }} md={{ span:2, offset:2 }}>
                        <Card.Img className='character-thumbnail' src={"/assets/character/thumbnail/006.jpg"} alt="" onClick = {() => openModal('006.jpg')} />
                    </Col>
                </Row>
                <Row >
                    <Col xs={{span:2, offset:0}} md={{ span:2, offset:2}} className='character-modeling-centeral-row'>
                        <Card.Img className='character-thumbnail' src={"/assets/character/thumbnail/004.jpg"} alt="" onClick = {() => openModal('004.jpg')} />
                    </Col>
                    <Col xs={{span:4, offset:1}} md={{ span:4, offset:0 }}>
                        <div className="character-model-player">
                            <CharacterModalPlayer name={characterName} />
                        </div>
                    </Col>
                    <Col xs={{span:2, offset:2}} md={{ span:2, offset:0 }} className='character-modeling-centeral-row'>
                        <Card.Img className='character-thumbnail' src={"/assets/character/thumbnail/007.jpg"} alt="" onClick = {() => openModal('007.jpg')} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ span:2, offset:1 }} md={{ span:2, offset:3 }} >
                        <Card.Img className='character-thumbnail' src={"/assets/character/thumbnail/003.jpg"} alt="" onClick = {() => openModal('003.jpg')} />
                    </Col>
                    <Col xs={{ span:2, offset:5 }} md={{ span:2, offset:2 }}>
                        <Card.Img className='character-thumbnail' src={"/assets/character/thumbnail/001.jpg"} alt="" onClick = {() => openModal('001.jpg')} />
                    </Col>
                </Row>
            </Card>
        </Card>
    </>
  )
}

export default CharacterModeling
